import { render } from "./breakdownFacade.vue?vue&type=template&id=0cfe5971"
import script from "./breakdownFacade.vue?vue&type=script&lang=js"
export * from "./breakdownFacade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__